var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 3.83333C8.66675 3.21449 8.91258 2.621 9.35017 2.18342C9.78775 1.74583 10.3812 1.5 11.0001 1.5C11.6189 1.5 12.2124 1.74583 12.65 2.18342C13.0876 2.621 13.3334 3.21449 13.3334 3.83333C14.6732 4.46687 15.8154 5.45305 16.6375 6.68618C17.4596 7.91932 17.9306 9.35292 18.0001 10.8333V14.3333C18.0879 15.0587 18.3448 15.7532 18.75 16.3611C19.1553 16.9691 19.6977 17.4733 20.3334 17.8333H1.66675C2.30251 17.4733 2.84486 16.9691 3.25013 16.3611C3.65541 15.7532 3.91228 15.0587 4.00008 14.3333V10.8333C4.06957 9.35292 4.5406 7.91932 5.36269 6.68618C6.18478 5.45305 7.32694 4.46687 8.66675 3.83333",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.8334V19C7.5 19.9283 7.86875 20.8185 8.52513 21.4749C9.1815 22.1313 10.0717 22.5 11 22.5C11.9283 22.5 12.8185 22.1313 13.4749 21.4749C14.1313 20.8185 14.5 19.9283 14.5 19V17.8334",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.49585807b309a84ffba4462062a11595.svg";
export { ForwardRef as ReactComponent };